export const GET_MY_ATTRIBUTES = 'GET_MY_ATTRIBUTES';
export const UPLOAD_SELFIE = 'UPLOAD_SELFIE';
export const UPLOAD_FND_IMAGE = 'UPLOAD_FND_IMAGE';
export const FETCH_HISTORY_REQUEST = 'FETCH_HISTORY_REQUEST';
export const FETCH_DATA_BY_DATE_RANGE = 'FETCH_DATA_BY_DATE_RANGE';
export const FETCH_SELFIE_REQUEST = 'FETCH_SELFIE_REQUEST';
export const FETCH_SELFIE_ATTRIBUTES = 'FETCH_SELFIE_ATTRIBUTES';
export const SAVE_SELFIE_DATA = 'SAVE_SELFIE_DATA';
export const FETCH_SELFIE_HISTROY_ATTRIBUTES = 'FETCH_SELFIE_HISTROY_ATTRIBUTES';
export const CLEAR_SELFIE_DATA = 'CLEAR_SELFIE_DATA';
export const SAVE_SELFIE_IMAGE = 'SAVE_SELFIE_IMAGE';

export const uploadSkinImage = (
  base64Data,
  analysisReviewPopupRequired = true,
  callback,
) => {
  return {
    type: UPLOAD_SELFIE,
    base64Data,
    analysisReviewPopupRequired,
    callback,
  };
};

export const uploadFNDImage = (imageUrl) => {
  return {
    type: UPLOAD_FND_IMAGE,
    imageUrl,
  };
};

export const fetchHistoryRequest = (params, callback) => {
  return {
    type: FETCH_HISTORY_REQUEST,
    payload: params,
    callback,
  };
};

export const fetchSelfieAttributes = (image_id, callback) => {
  return {
    type: FETCH_SELFIE_ATTRIBUTES,
    image_id,
    callback,
  }
};

export function saveSelfieData(data) {
  return { type: SAVE_SELFIE_DATA, data };
}

export const fetchSelfieHistroyAttributes = (params, callback) => {
  return {
    type: FETCH_SELFIE_HISTROY_ATTRIBUTES,
    payload: params,
    callback,
  }
}

export function clearSelfieData() {
  return { type: CLEAR_SELFIE_DATA };
}

export function saveSelfieImage(data) {
  return { type: SAVE_SELFIE_IMAGE, data };
}
